import { render, staticRenderFns } from "./sameTypeArticle.vue?vue&type=template&id=ba180c0e&scoped=true&"
import script from "./sameTypeArticle.vue?vue&type=script&lang=js&"
export * from "./sameTypeArticle.vue?vue&type=script&lang=js&"
import style0 from "./sameTypeArticle.vue?vue&type=style&index=0&id=ba180c0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba180c0e",
  null
  
)

export default component.exports